import {
  getCustomerAppDocRetrieveQueryKey,
  getCustomerApplicationsRetrieveQueryKey,
  getCustomerFundingNeedsRetrieveQueryKey,
} from "@boundless/bl-api-client/customer/services"

import type { QueryClient } from "@tanstack/react-query"

type ApplicationDocumentQueryIdentifiers = {
  companyUuid: string
  fundingNeedsUuid: string
  applicationUuid: string
}

export function invalidateApplicationDocumentQueries(
  queryClient: QueryClient,
  {
    companyUuid,
    fundingNeedsUuid,
    applicationUuid,
  }: ApplicationDocumentQueryIdentifiers,
) {
  return Promise.all([
    queryClient.invalidateQueries({
      queryKey: getCustomerAppDocRetrieveQueryKey(
        companyUuid,
        fundingNeedsUuid,
      ),
    }),
    queryClient.invalidateQueries({
      queryKey: getCustomerFundingNeedsRetrieveQueryKey(
        companyUuid,
        fundingNeedsUuid,
      ),
    }),
    queryClient.invalidateQueries({
      queryKey: getCustomerApplicationsRetrieveQueryKey(
        companyUuid,
        applicationUuid,
      ),
    }),
  ])
}
